import React, { useEffect, useState } from "react";
import { Table, Modal, Button, message } from "antd";
import {
  useAddFinancialInstituteToOrder,
  useGetBanksByOrderId,
  useRemoveBankFromOrder,
} from "../../../api/order";
import TableAction from "../../TableAction";
import { FinancialInstituteSelect } from "../../form/FinancialInstituteSelect";

type bankTableProps = {
  orderId: string;
};

const BanksTable: React.FC<bankTableProps> = ({ orderId }) => {
  const { data, refetch, isLoading } = useGetBanksByOrderId(orderId);
  const [tableData, setTableData] = useState<any[]>([]);
  const [bankId, setBankId] = useState<string | undefined>();
  const [selectedId, setSelectedId] = useState<number | undefined>();

  const { mutateAsync: assignBank, isPending } =
    useAddFinancialInstituteToOrder();
  const { mutateAsync: removeBankFromOrder, isPending: removing } =
    useRemoveBankFromOrder();

  const [searchText, setSearchText] = useState<string>("");
  const [open, setOpen] = useState(false);
  const [removeOpen, setRemoveOpen] = useState(false);

  const handleCreate = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const hideRemoveModal = () => {
    setRemoveOpen(false);
  };

  useEffect(() => {
    if (data && data.data && data.data.data) {
      const _data = data.data.data.map((item: any) => {
        return {
          id: item.id,
          name: item.org.name,
          email: item.org.email,
          phoneNumber: item.org.phoneNumber,
        };
      });

      setTableData(_data);
    }
  }, [data]);

  const onSubmit = async () => {
    if (bankId && orderId) {
      try {
        const result = await assignBank({
          orderId: Number(orderId),
          orgId: Number(bankId),
        });

        if (result.status === 200) {
          message.success("Financial institute assigned successfully.");
        } else {
          message.error("Operation failed.");
        }
      } catch (err: any) {
        message.error("Operation failed.");
      } finally {
        refetch();
        setOpen(false);
      }
    }
  };

  const onRemove = async () => {
    if (selectedId) {
      try {
        const result = await removeBankFromOrder(selectedId);

        if (result.status === 200) {
          message.success("Financial institute assigned successfully.");
        } else {
          message.error("Operation failed.");
        }
      } catch (err: any) {
        message.error("Operation failed.");
      } finally {
        refetch();
        setRemoveOpen(false);
      }
    }
  };

  const bankColumn = [
    {
      title: "No.",
      width: 60,
      render: (text: string, record: any, index: number) => <b>#{index + 1}</b>,
    },
    {
      dataIndex: "name",
      title: "Name",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Phone number",
      dataIndex: "phoneNumber",
    },
    {
      title: "Action",
      dataIndex: "id",
      render: (id: number) => {
        return (
          <Button
            onClick={() => {
              setSelectedId(id);
              setRemoveOpen(true);
            }}
          >
            Remove
          </Button>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        open={removeOpen}
        title={<div className="text-black">Remove</div>}
        onOk={onRemove}
        onCancel={hideRemoveModal}
        okButtonProps={{
          disabled: removing,
          loading: removing,
        }}
      >
        <div className="text-black">
          Are you sure you want to remove the selected bank from this order?
        </div>
      </Modal>
      <Modal
        destroyOnClose={true}
        title={
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 600,
              fontSize: 27.43,
              color: "black",
            }}
          >
            Select financial institute
          </div>
        }
        open={open}
        centered
        onOk={onSubmit}
        okButtonProps={{
          disabled: bankId === undefined || isPending,
          loading: isPending,
        }}
        onCancel={hideModal}
        closable
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <FinancialInstituteSelect
            value={bankId}
            onChange={(val) => setBankId(val)}
          />
        </div>
      </Modal>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          height: 80,
          backgroundColor: "#EEF3F8",
          borderRadius: 8.4,
          marginBottom: 12,
        }}
      >
        <TableAction setSearchText={setSearchText} onCreateNew={handleCreate} />
      </div>
      <Table
        style={{
          cursor: "pointer",
          position: "relative",
          zIndex: 100,
          overflowY: "hidden",
        }}
        scroll={{ y: 600 }}
        dataSource={tableData || []}
        columns={bankColumn}
        loading={isLoading}
      />
    </>
  );
};

export default BanksTable;
